import { createContext, RefObject, useContext } from 'react';

import type { RouteLayout } from '~/features/app/useRouteLayout';

interface AppShellContextValue {
  layout?: RouteLayout;
  activePanelId: string | null;
  openPanel: (key: string) => void;
  closePanel: () => void;
  mountedPanelKeys?: ReadonlySet<string>;
  stickyHeaderOffset?: number;
  floatingBoundsRef?: RefObject<HTMLElement | null>;
}

const NO_MOUNTED_PANELS: ReadonlySet<string> = new Set();

export const AppShellContext = createContext<AppShellContextValue>({
  layout: undefined,
  activePanelId: null,
  openPanel: () => {},
  closePanel: () => {},
  mountedPanelKeys: NO_MOUNTED_PANELS,
  stickyHeaderOffset: undefined,
  floatingBoundsRef: undefined,
});

export function useAppShell() {
  return useContext(AppShellContext);
}
